<template>
  <div class="current-turn">
    <span class="turn-number">{{ currentTurn || "..." }}</span>
    <span class="turn-phase" v-if="currentPhase">{{ formattedPhase }}</span>
    <!-- Levers that act on the clock this chip is already reporting. They hang
         off the counter rather than arriving as a second one: whoever may step
         the clock still reads the cycle and phase from here. -->
    <span class="turn-controls"><slot name="controls"/></span>
  </div>
</template>

<script>
import { ActionGameApi } from "@/api/backendService.js";

export default {
  name: "CurrentTurnComponent",
  props: {
    currentTurn: Number, // Current turn number
    currentPhase: String, // Current cycle phase (preparation, action, etc.)
  },
  computed: {
    // Dynamically calculate font size based on the number of digits in currentTurn
    dynamicFontSize() {
      if (!this.currentTurn) return "1.2rem";

      const digits = this.currentTurn.toString().length;

      // Reduce font size as digit count increases
      if (digits <= 2) return "1.4rem";
      if (digits <= 3) return "1.2rem";
      if (digits <= 4) return "1rem";
      if (digits <= 5) return "0.9rem";
      return "0.75rem";
    },
    // Format phase name for display (capitalize first letter)
    formattedPhase() {
      if (!this.currentPhase) return "";
      return this.currentPhase.charAt(0).toUpperCase() + this.currentPhase.slice(1);
    }
  },
  methods: {
    async fetchCurrentTurn() {
      try {
        const response = (await ActionGameApi.actionCurrentCycleRetrieve()).data;
        // Return the cycle number from the new GameCycle structure
        return response.number;
      } catch (error) {
        console.error("Failed to fetch current turn:", error);
        return null;
      }
    },
  },
  mounted() {},
  beforeUnmount() {},
};
</script>

<style scoped>
.current-turn {
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.6rem;
  background: rgba(13, 13, 13, 0.6);
  color: #00ffff;
  font-family: "Orbitron", sans-serif;
  border-radius: 6px;
  border: 1px solid rgba(0, 255, 255, 0.3);
  font-size: 0.85rem;
  backdrop-filter: blur(4px);
  transition: border-color 0.3s ease;
}

.current-turn:hover {
  border-color: rgba(0, 255, 255, 0.5);
}

.turn-number {
  font-weight: 700;
  line-height: 1;
  color: #00ffff;
}

.turn-phase {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(0, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1;
}

.turn-phase::before {
  content: "•";
  margin-right: 0.5rem;
  color: rgba(0, 255, 255, 0.5);
}

/* The chip itself is inert so the board stays clickable through it; anything
   dropped into the slot has to opt back in. Empty slot costs no width. */
.turn-controls {
  display: contents;
  pointer-events: auto;
}
</style>
